define('dialogs_manager',['underscore', 'utils/constants', 'utils/wrapper', 'runtime', 'sdk/ui', 'rpc'], function(_, CONST, __w, Runtime, UI, RPC) {
  var dialogURI = function(path) {
    return CONST.root_url + '/dialogs/' + path;
  };

  var DialogsManager = {
    open: function(options, successCb, errorCb) {
      options = options || {};
      options.app_id = Runtime.getAppId();

      switch(options.method) {
      case 'apprequests':
        UI.createIframeDialog(successCb, errorCb, dialogURI('app_requests/new'), _.pick(options, "message", "redirect_uri", "data", "app_id", "to"));
        break;
      case 'friends':
        UI.createIframeDialog(successCb, errorCb, dialogURI('friends/new'), _.pick(options, "redirect_uri", "app_id", "id"));
        break;
      case 'feed':
        options = _.pick(options, "link", "description", "picture", "source", "name", "caption", "message", "redirect_uri", "app_id");
        UI.createIframeDialog(successCb, errorCb, dialogURI('feeds/new'), options);
        break;
      case 'leaderboard':
        UI.createIframeDialog(successCb, errorCb, dialogURI('leaderboard'), _.pick(options, "redirect_uri", "app_id"));
        break;
      case 'achievements':
        return UI.createIframeDialog(successCb, errorCb, dialogURI('achievements'), _.pick(options, "redirect_uri", "app_id", "h", "q"));
      case 'advanced_scores':
        return UI.createIframeDialog(successCb, errorCb, dialogURI('advanced_scores'), _.pick(options, 'redirect_uri', 'app_id', 'h', 'q', 'u'));
      case 'certification':
        UI.createIframeDialog(successCb, errorCb, dialogURI('certification'), _.pick(options, "redirect_uri", "app_id"));
        break;
      case 'points_leaderboard':
        UI.createIframeDialog(successCb, errorCb, dialogURI('leaderboard/points'), options);
        break;
      }
    }
  };

  RPC.events['dialog.finished'] = function(object){
    var dialog = UI.getDialog(object.dialog_id);
    dialog.inform('dialog.finished', null);
    dialog.call(object.data);
  };

  RPC.events['dialog.error'] = function(object){
    var dialog = UI.getDialog(object.dialog_id);
    dialog.inform('dialog.error', null);
    dialog.error(object.error, object.data);
  };

  RPC.events['dialog.resize'] = function(object){
    var dialog = UI.getDialog(object.dialog_id);
    dialog.inform('dialog.resize', object.width, object.height, object.overflow);
    // Save the iframe content height coming from easyXDM
    dialog.contentWidth = object.width;
    dialog.contentHeight = object.height;
    UI.centerDialog(dialog);
  }

  return DialogsManager;
});

